const EVENT_CLIPBOARD_KEY = "calendarCopiedEvent";
const EVENT_CLIPBOARD_TTL_MS = 24 * 60 * 60 * 1000;

const parseClipboard = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    localStorage.removeItem(EVENT_CLIPBOARD_KEY);
    return null;
  }
};

export const setCopiedEventReference = (eventId) => {
  if (!eventId) return null;

  const copiedAt = new Date().toISOString();
  const expiresAt = new Date(Date.now() + EVENT_CLIPBOARD_TTL_MS).toISOString();

  const payload = {
    eventId,
    copiedAt,
    expiresAt,
    version: 1,
  };

  localStorage.setItem(EVENT_CLIPBOARD_KEY, JSON.stringify(payload));
  return payload;
};

export const getCopiedEventReference = () => {
  const clipboard = parseClipboard(localStorage.getItem(EVENT_CLIPBOARD_KEY));
  if (!clipboard?.eventId || !clipboard?.expiresAt) {
    if (clipboard) {
      localStorage.removeItem(EVENT_CLIPBOARD_KEY);
    }
    return null;
  }

  if (new Date(clipboard.expiresAt).getTime() <= Date.now()) {
    localStorage.removeItem(EVENT_CLIPBOARD_KEY);
    return null;
  }

  return clipboard;
};

export const hasCopiedEventReference = () => Boolean(getCopiedEventReference());

export const clearCopiedEventReference = () => {
  localStorage.removeItem(EVENT_CLIPBOARD_KEY);
};

export { EVENT_CLIPBOARD_KEY };
